export default __webpack_public_path__ + "react/static/greenStick-24eeded0639d133325cab0851d9c65aa.png";